import { Component, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { AttachmentType } from 'src/app/shared';

@Component({
    standalone: false,
    selector: 'app-zoning-code-version-details',
    templateUrl: './zoning-code-version-details.component.html',
    styleUrls: ['./zoning-code-version-details.component.scss']
})
export class zoningCodeVersionsDetailsComponent {
    @Input()
    public sidenav: MatSidenav;

    @Input()
    public isLoaded: boolean = false;

    @Input()
    public width: number;

    @Input()
    public currentSideNavWidth: number;

    @Output()
    public isWidthChange = new EventEmitter<number>();

    @Input()
    public detailsData: any;

    @Input()
    public attachmentType: AttachmentType;

    public oldX: number = 0;
    public grabber: boolean = false;

    onMouseMove(event: MouseEvent) {
        if (!this.grabber) {
            return;
        }

        this.resizer(event.clientX - this.oldX);
        this.oldX = event.clientX;
    }

    @HostListener('document:mouseup')
    onMouseUp() {
        this.grabber = false;
    }

    resizer(offsetX: number) {
        this.width -= offsetX;
        this.isWidthChange.emit(this.width);
    }

    onMouseDown(event: MouseEvent) {
        this.grabber = true;
        this.oldX = event.clientX;
    }
}
